import axios from '@axios'

export default function configuracaoTelaApi(recursoId) {
  return {
    obter: () => axios.get(`configuracao-tela/${recursoId}`),
    salvar: configuracaoJson => axios.put(`configuracao-tela/${recursoId}`, { configuracaoJson }),
  }
}
